module.exports = __webpack_public_path__ + "img/ic_bed_sandh_5.3710e29a.png";